export default "__VITE_ASSET__cCXYbrTA__"